// Should stay in sync with ValidationErrorCodes.mjs

export const VALIDATION_ERROR_CODES = {
  APPRAISER_REACHED_EVENTS_LIMIT: 'APPRAISER_REACHED_EVENTS_LIMIT'
};
